exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ws-nowrap{white-space:nowrap!important}.hover-container{position:relative}.hover-container:hover .hover-content{visibility:visible;opacity:1}.hover-content{visibility:hidden;opacity:0;transition:all .3 linear;position:absolute;top:-10px;right:130px;z-index:1000;background-color:#fff;border:1px solid #e4e7ed;border-radius:8px!important;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);padding:8px 16px;width:310px}.popover-arrow{right:-7px;transform:rotate(135deg)}.popover-arrow,.popover-arrow-left{position:absolute;top:25px;z-index:3000;height:13px;width:13px;border-radius:0;border:1px solid #e4e7ed;background:#fff;border-bottom:none;border-right:none}.popover-arrow-left{left:-7px;transform:rotate(-45deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-377517e2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 426
// module chunks = 0